import { useEffect, useState, useContext } from 'react';
import {  NavLink, useRouteLoaderData, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FileDisplay from '../utils/FileDisplay';
import LabIDContext from '../store/LabIDContext';
import { getLabConfig, getOrderStatus } from '../utils/api';

import CartClasses from '../components/Cart/Cart.module.css';


const Success = () => {
	const token = useRouteLoaderData('root');
	const labid = useContext(LabIDContext);
	const [webURL, setWebURL] = useState([]);
	const [orderStatus, setOrderStatus] = useState([]);
	const location = useLocation();
	const reqNumber = location.state.orderInfo || '';
	console.log(reqNumber);
	console.log(location.state);
	useEffect(() => {
        async function fetchLabSetting() {
            const webURL = await getLabConfig('WEBSERVER');
            setWebURL(webURL);
        }
        fetchLabSetting();
    }, []);
	useEffect(() => {
        async function fetchStatus() {
            const ostatus = await getOrderStatus(reqNumber);
            setOrderStatus(ostatus);
        }
        fetchStatus();
    }, [reqNumber]);
	console.log(orderStatus);
	const ReqURL = webURL + labid + '/lpi3/?event=dtc.DTC&reqnumlist=';

    return (
       <div className={CartClasses.testInfo}>
    	    <div className={CartClasses.testInfoContent}>
				 <FileDisplay filePath={`./${labid}_Complete.js`} labid={labid} />
				{(orderStatus === "CYNERGY Approved" || orderStatus === '' ) && 
					(<div><p>Order sent to lab.</p>
					<p><a href= {ReqURL + reqNumber + '&token=' + token}  target="_prtReq" title="Print Requistion" rel="noopener noreferrer">Click here to Print Order Requistion</a></p>
					<NavLink to='../drawLocations' state={{orderInfo: reqNumber}}>Click here to View Draw Location Information</NavLink>
				   </div>)
				 }
				{orderStatus === "CYNERGY Rejected" && (<div>Your order has been denied by the approving physician service.  Your credit card payment should be reversed, but may take several days to appear.</div>)}
				{orderStatus === "No qualifying Order Code Found" && (<div>Your order does not qualify for self-testing.  Your credit card payment should be reversed, but may take several days to appear.</div>)}
				{orderStatus === "Submitted" && (<div>Your order is currently being reviewed by our physician service.  This should only take a few minutes. Please click <NavLink to='../cynergy' state={{orderInfo: reqNumber}}>here</NavLink> to refresh the screen and see your status.</div>)}
			</div>
		</div>
	);
};

export default Success;
